import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createSlots as _createSlots, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/logo-w.png'


const _hoisted_1 = { class: "hd-right" }
const _hoisted_2 = { href: "javascript:;" }

import { defineComponent, reactive, toRefs, ref, watch, unref, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex'
import menuList from '@/router/menu'
import { storage } from '@/utils/storage'
import {getInviteLink, resetSelf} from "@/api/system";
import { copy } from "@/utils/util";
import {message} from "ant-design-vue";
import ResetPswModal from "@/components/user/resetPswModal.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'layout',
  setup(__props) {

const store = useStore()
let route = useRoute()
let router = useRouter()
const { currentRoute } = useRouter()

const menuState = reactive({
  selectedKeys: ['/loan/apply'],
  openKeys: ['/loan']  // 默认展开的节点
});
const rootSubMenuKeys: string[] = [];
const useMenu = store.getters.menus
const menuAct = ref([])
try {
  for(let menu of menuList) {
    if (menu.children && menu.children.length > 0) {
      if (useMenu.includes(menu.name as string)) {
        menuAct.value.push(menu)
      } else {
        const menuItem =  menu.children.filter(menuItem => {
          return useMenu.includes(menuItem.name as string)
        })
        if (menuItem.length > 0) {
          let newMenu = menu
          newMenu.children = menuItem
          menuAct.value.push(newMenu)
        }
      }
    } else {
      if (useMenu.includes(menu.name as string)) menuAct.value.push(menu)
    }
  }
  for (const { children, path } of menuList) {
    if (children && children.length > 0) {
      rootSubMenuKeys.push(path);
    }
  }
} catch (e) {
  router.replace('/login')
}

handleMenuChange()

watch(() => route.path,val => {
      //当路由变化时，拿到当前路由所在模块的key
      if (val) {
        // menuState.selectedKeys = [val];
        handleMenuChange()
      }
    }
);

function onOpenChange(openKeys: string[]) {
  const latestOpenKey = openKeys.find(key => {
    return menuState.openKeys.indexOf(key) === -1
  });
  if (rootSubMenuKeys.indexOf(latestOpenKey!) === -1) {
    menuState.openKeys = openKeys;
  } else {
    menuState.openKeys = latestOpenKey ? [latestOpenKey] : [];
  }
}

async function handleMenuClick({ item, key }: { item: any; key: string; keyPath: string[] }) {
  await router.push(key)
  menuState.selectedKeys = [key];
}

function handleMenuChange() {
  const path = unref(currentRoute).path
  let r = path.split('/')
  menuState.openKeys = ['/' + r[1]]
  menuState.selectedKeys = [path]
}

const pswModalVisible = ref<boolean>(false)
function resetPsw() {
  pswModalVisible.value = true
}
function pswModalVisibleChange(e: boolean) {
  pswModalVisible.value = e
}
function resetPswApi(value: string) {
  resetSelf({
    password: value
  }).then(() => {
    message.success('重置密码成功！')
    logout()
  })
}

function logout() {
  store.dispatch('Logout')
}

const copyInvite = () => {
  getInviteLink().then(res => {
    copy(res.data)
    message.success('专属链接已复制！')
  })
}

const menuVisible = ref<boolean>(false)

function toIndex() {
  router.push('/')
}

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "header" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "logo flex-wrp",
            onClick: toIndex
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
            _createVNode(_component_a_divider, { type: "vertical" }),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "贷款管理平台", -1))
          ]),
          _createElementVNode("div", _hoisted_1, [
            _cache[9] || (_cache[9] = _createTextVNode("欢迎您， ", -1)),
            _createVNode(_component_a_popover, { placement: "bottom" }, {
              content: _withCtx(() => [
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  size: 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "text",
                      onClick: copyInvite
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("我的邀请码", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "text",
                      onClick: resetPsw
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("重置密码", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "text",
                      onClick: logout
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("退出登录", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$store.state.user.name), 1),
                _createVNode(_component_a_avatar, {
                  src: _ctx.$store.state.user.avatar,
                  style: {"margin-left":"14px"}
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_UserOutlined)
                  ]),
                  _: 1
                }, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_menu_unfold_outlined, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (menuVisible.value = true))
          }),
          _createVNode(_component_a_drawer, {
            open: menuVisible.value,
            "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((menuVisible).value = $event)),
            width: 200
          }, {
            default: _withCtx(() => [
              (_unref(menuList) && _unref(menuList).length > 0)
                ? (_openBlock(), _createBlock(_component_a_menu, {
                    key: 0,
                    selectedKeys: menuState.selectedKeys,
                    "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((menuState.selectedKeys) = $event)),
                    mode: "inline",
                    style: { height: '100%', borderRight: 0 },
                    onClick: handleMenuClick,
                    openKeys: menuState.openKeys,
                    onOpenChange: onOpenChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuAct.value, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.path
                        }, [
                          (!item.children)
                            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: item.path
                              }, _createSlots({
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(item.meta.label), 1)
                                ]),
                                _: 2
                              }, [
                                (item.meta.icon)
                                  ? {
                                      name: "icon",
                                      fn: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$antIcons[item.meta.icon])))
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1024))
                            : (_openBlock(), _createBlock(_component_a_sub_menu, {
                                key: item.path,
                                title: item.meta.label 
                              }, _createSlots({
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (_item) => {
                                    return (_openBlock(), _createBlock(_component_a_menu_item, {
                                      key: _item.path
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_item.meta.label), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, [
                                (item.meta.icon)
                                  ? {
                                      name: "icon",
                                      fn: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$antIcons[item.meta.icon])))
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1032, ["title"]))
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["selectedKeys", "openKeys"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["open"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          (!_ctx.$route.meta.hideSideBar)
            ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                key: 0,
                width: "190",
                class: "sider",
                theme: "light"
              }, {
                default: _withCtx(() => [
                  (_unref(menuList) && _unref(menuList).length > 0)
                    ? (_openBlock(), _createBlock(_component_a_menu, {
                        key: 0,
                        selectedKeys: menuState.selectedKeys,
                        "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((menuState.selectedKeys) = $event)),
                        mode: "inline",
                        style: { height: '100%', borderRight: 0 },
                        onClick: handleMenuClick,
                        openKeys: menuState.openKeys,
                        onOpenChange: onOpenChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuAct.value, (item) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: item.path
                            }, [
                              (!item.children)
                                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: item.path
                                  }, _createSlots({
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(item.meta.label), 1)
                                    ]),
                                    _: 2
                                  }, [
                                    (item.meta.icon)
                                      ? {
                                          name: "icon",
                                          fn: _withCtx(() => [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$antIcons[item.meta.icon])))
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1024))
                                : (_openBlock(), _createBlock(_component_a_sub_menu, {
                                    key: item.path,
                                    title: item.meta.label 
                                  }, _createSlots({
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (_item) => {
                                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                                          key: _item.path
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_item.meta.label), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, [
                                    (item.meta.icon)
                                      ? {
                                          name: "icon",
                                          fn: _withCtx(() => [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$antIcons[item.meta.icon])))
                                          ]),
                                          key: "0"
                                        }
                                      : undefined
                                  ]), 1032, ["title"]))
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["selectedKeys", "openKeys"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_layout, {
            style: _normalizeStyle([{"margin":"60px 0px 0 191px"}, {marginLeft: _ctx.$route.meta.hideSideBar ? '0' : '191px'}]),
            class: "lay-content"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_content, { style: { padding: '0', margin: 0 } }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view, null, {
                    default: _withCtx(({ Component, route }) => [
                      (_openBlock(), _createBlock(_KeepAlive, null, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                          key: route.fullPath
                        }))
                      ], 1024))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }),
      _createVNode(ResetPswModal, {
        visible: pswModalVisible.value,
        onVisibleChange: pswModalVisibleChange,
        onResetSubmit: resetPswApi
      }, null, 8, ["visible"])
    ]),
    _: 1
  }))
}
}

})